export { default } from "./RegistroMovimientosCajas";
